export default __webpack_public_path__ + "static/media/Icon-trophy.92e0a176.svg";